module.exports = __webpack_public_path__ + "img/event.e7b39765.svg";